// Redirects /terms in the app to the canonical apex terms at keyflow.homes.
// Kept as a route handler so any deep links (Google OAuth branding, old bookmarks,
// emails) continue to resolve to the current terms.

import React from 'react';

const APEX_URL = 'https://keyflow.homes/terms';

function TermsOfService() {
    React.useEffect(() => {
        window.location.replace(APEX_URL);
    }, []);

    return (
        <div className="p-10 text-center text-[color:var(--text-muted)]">
            Redirecting to <a href={APEX_URL} className="underline">{APEX_URL}</a>…
        </div>
    );
}

export default TermsOfService;
